import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesTrackMain } from './modules/ui/Main';

const TrackPage = (
  <SuspensePage>
    <PagesTrackMain />
  </SuspensePage>
);

export default TrackPage;
